import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PersonalBookRecordingPage from '../pages/PersonalBookRecordingPage';
import API_URL from '../config/API_URL';

const PersonalBookRecordingWrapper = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const bookId = searchParams.get('bookId');
    
    useEffect(() => {
        const fetchBook = async () => {
            try {
                const response = await fetch(`${API_URL}/api/personal-books/${bookId}`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const data = await response.json();
                    setBook(data);
                } else {
                    console.error('Failed to fetch book');
                    navigate('/grandparent-dashboard');
                }
            } catch (error) {
                console.error('Error fetching personal book:', error);
                navigate('/grandparent-dashboard');
            } finally {
                setLoading(false);
            }
        };
        
        if (bookId) {
            fetchBook();
        } else {
            navigate('/grandparent-dashboard');
        }
    }, [bookId, navigate]);
    
    if (loading) {
        return (
            <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <p style={{ fontSize: '1.25rem', color: '#6b7280' }}>Loading book...</p>
            </div>
        );
    }
    
    if (!book) {
        return (
            <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <p style={{ fontSize: '1.25rem', color: '#6b7280' }}>Book not found</p>
            </div>
        );
    }
    
    return (
        <PersonalBookRecordingPage 
            book={book} 
            onComplete={() => navigate('/grandparent-dashboard')}
        />
    );
};

export default PersonalBookRecordingWrapper;